export default {
  authenticated: false,
  token: '',
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js